module.exports = __webpack_public_path__ + "img/page4.83996e09.jpg";